import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import { API_URL, API_Authentication, API_Citizen } from './apiconfig';
import { ProfileInfo, Login } from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class LoginService {

    public profileInfo: ProfileInfo;
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    private apiUrl: string;
    constructor(private _http: Http) {
        this.apiUrl = API_URL;
    }

    // Get Agency Info
 
    login(userName: string, passWord: string, jurisNo: number): Promise<Login> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Authentication + "/" + userName + "/" + encodeURIComponent(passWord) + "/" + jurisNo, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                let objLogin: Login;
                objLogin = response.json();
                objLogin.Token = response.headers.get("token");

                return objLogin;
            })
            .catch(this.handleError);
    }

    // Edit Profile

    editProfile(citizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + API_Citizen + "/" + citizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                if (response.json()[0]) {
                    this.profileInfo = {
                        CitizenID: (response.json()[0].CitizenID !== null ? response.json()[0].CitizenID : ""),
                        JurisID: (response.json()[0].JurisID !== null ? response.json()[0].JurisID : ""),
                        FirstName: (response.json()[0].FirstName !== null ? response.json()[0].FirstName : ""),
                        LastName: (response.json()[0].LastName !== null ? response.json()[0].LastName : ""),
                        MiddleName: (response.json()[0].MiddleName !== null ? response.json()[0].MiddleName : ""),
                        Email: (response.json()[0].Email !== null ? response.json()[0].Email : ""),
                        PrimaryNumber: ((response.json()[0].PhoneNumber[0]) ? (response.json()[0].PhoneNumber[0] !== null && response.json()[0].PhoneNumber[0].PhoneNbr !== null) ? response.json()[0].PhoneNumber[0].PhoneNbr : "" : ""),
                        AlternateNumber: ((response.json()[0].PhoneNumber[1]) ? (response.json()[0].PhoneNumber[1] !== null && response.json()[0].PhoneNumber[1].PhoneNbr !== null) ? response.json()[0].PhoneNumber[1].PhoneNbr : "" : ""),
                    }
                }
                return this.profileInfo;
            })
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/login.service.ts